import store from "@/state/store";
export default [
  {
      path: "/404",
      name: "login",
      component: () => import("../pages/utility/404"),
      meta: {
          beforeResolve(routeTo, routeFrom, next) {
              if (store.getters["authStore/loggedIn"]) {
                  next({name: "default"});
              } else {
                  next();
              }
          }
      },
  },
  /*******************NEW*****************/ 
  {
    path: "/loai-sen-admin",
    name: "default",
    meta: {},
    component: () => import("../pages/quantri/loaiSen"),
  },
  {
    path: "/mon-an-sen-admin",
    name: "default",
    meta: {},
    component: () => import("../pages/quantri/monAnSen"),
  },
  {
    path: "/doanh-nghiep-admin",
    name: "default",
    meta: {},
    component: () => import("../pages/quantri/doanhNghiep"),
  },
  {
    path: "/san-pham-sen-admin",
    name: "default",
    meta: {},
    component: () => import("../pages/quantri/sanPhamSen"),
  },
  {
    path: "/sen-admin",
    name: "default",
    meta: {},
    component: () => import("../pages/quantri/sen"),
  },
  {
    path: "/du-lich-sen-admin",
    name: "default",
    meta: {},
    component: () => import("../pages/quantri/duLichSen"),
  },

  {
    path: "/tin-noi-bat-admin",
    name: "default",
    meta: {},
    component: () => import("../pages/quantri/tinnoibat"),
  },

  /*******************CÔNG DÂN********************/ 

  {
    path: "/du-lich-sen",
    name: "default",
    meta: {},
    component: () => import("../pages/duLichSenCategory"),
  },

  {
    path: "/du-lich-sen/chi-tiet/:id?",
    name: "default",
    meta: {},
    component: () => import("../pages/duLichSenCategory/chitiet"),
  },
  {
    path: "/sen",
    name: "default",
    meta: {},
    component: () => import("../pages/senCategory"),
  },

  {
    path: "/sen/chi-tiet/:id?",
    name: "default",
    meta: {},
    component: () => import("../pages/senCategory/chitiet"),
  },
  {
    path: "/mon-an-sen",
    name: "default",
    meta: {},
    component: () => import("../pages/monAnSenCategory"),
  },

  {
    path: "/mon-an-sen/chi-tiet/:id?",
    name: "default",
    meta: {},
    component: () => import("../pages/monAnSenCategory/chitiet"),
  },
  {
    path: "/san-pham-sen",
    name: "default",
    meta: {},
    component: () => import("../pages/sanPhamSenCategory"),
  },

  {
    path: "/san-pham-sen-app",
    name: "default",
    meta: {},
    component: () => import("../pages/sanPhamSenApp"),
  },

  {
    path: "/san-pham-sen/chi-tiet/:id?",
    name: "default",
    meta: {},
    component: () => import("../pages/sanPhamSenCategory/chitiet"),
  },
  {
    path: "/ban-do",
    name: "default",
    meta: {},
    component: () => import("../pages/bando"),
  },

  {
    path: "/tin-noi-bat",
    name: "default",
    meta: {},
    component: () => import("../pages/tinnoibatCategory"),
  },

  {
    path: "/tin-noi-bat/chi-tiet/:id?",
    name: "default",
    meta: {},
    component: () => import("../pages/tinnoibatCategory/chitiet"),
  },


  /***************************************/ 
  {
    path: "/dang-nhap",
    name: "default",
    meta: {},
    component: () => import("../pages/quantri/login/login"),
  },
  {
    path: "/",
    name: "default",
    meta: {},
    component: () => import("../pages/congdan/home"),
  },
  

  // QUAN TRI

  {
    path: "/menu",
    name: "menu",
    meta: {},
    component: () => import("../pages/quantri/menu"),
  },

  {
    path: "/tai-khoan",
    name: "Tài khoản",
    meta: {},
    component: () => import("../pages/quantri/user"),
  },
  {
    path: "/tai-khoan/doi-mat-khau",
    name: "Đổi mật khẩu",
    meta: {},
    component: () => import("../pages/quantri/user/ChangePass"),
  },
  {
    path: "/menu-cong-dan",
    name: "menu",
    meta: {},
    component: () => import("../pages/quantri/menucongdan"),
  },
  {
    path: "/vai-tro",
    name: "Quyền",
    meta: {},
    component: () => import("../pages/quantri/unitRole"),
  },
  {
    path: "/vai-tro/thiet-lap-quyen/:id?",
    name: "Vai trò",
    meta: {},
    component: () => import("../pages/quantri/unitRole/addPermissions"),
  },

  {
    path: "/nhom-quyen",
    name: "Quản lý nhóm quyền",
    meta: {},
    component: () => import("../pages/quantri/module"),
  },
  {
    path: "/nhom-quyen/action/:id?",
    name: "Hành động",
    // meta: {},
    component: () => import("../pages/quantri/module/action"),
  },
  {
    path: "/thong-tin-ca-nhan",
    name: "Thông tin cá nhân",
    // meta: {},
    component: () => import("../pages/quantri/login/profile"),
  },
  {
    path: "/404",
    name: "404",
    component: require("../pages/utility/404").default,
  },
  {
    path: "/unauthorized",
    name: "401",
    component: require("../pages/utility/401").default,
  },
  {
    path: "*",
    redirect: "404",
  },

];
